import React from "react"
import { Heading, Section, Label, Container, Input, Dropdown } from "ui"
import KeyValueList from "../../studio/ui/KeyValueList"

const PageSettingsPane = props => {
    return (
        <Section margin="none" paddingTop="none">
            <Heading size="small">Page Settings</Heading>
            <Section margin="none">
                <Container>
                    <InputLabel>Name</InputLabel>
                    <Input
                        style={{ width: 200 }}
                        value={props.page.name}
                        onChange={e => {
                            console.log(e.target.value + "d")
                            props.savePage({ name: e.target.value })
                        }}
                    />
                </Container>
                <Container>
                    <InputLabel>Title</InputLabel>
                    <br />
                    <Input
                        style={{ width: 200 }}
                        value={props.page.options.title}
                        onChange={e => {
                            console.log(e.target.value + "d")
                            props.savePage({
                                options: { ...props.page.options, title: e.target.value },
                            })
                        }}
                    />
                </Container>
                <Container>
                    <InputLabel>Favicon</InputLabel>
                    <br />
                    <Input
                        style={{ width: 200 }}
                        value={props.page.options.favicon}
                        onChange={e => {
                            console.log(e.target.value + "d")
                            props.savePage({
                                options: { ...props.page.options, favicon: e.target.value },
                            })
                        }}
                    />
                </Container>
                <Container>
                    <InputLabel>Inputs</InputLabel>
                    <br />
                    <KeyValueList
                        value={props.page.options.inputs}
                        keyName="key"
                        valueName="label"
                        onChange={val => {
                            props.savePage({
                                options: { ...props.page.options, inputs: val },
                            })
                        }}
                    />
                </Container>
            </Section>
        </Section>
    )
}
export default PageSettingsPane

// onChange({ options: { ...page.options, name: e.target.value } })
const InputLabel = props => (
    <div>
        <Label style={{ width: 50 }}>{props.children}</Label>
    </div>
)



// WEBPACK FOOTER //
// ./src/features/editor/sidebars/PageSettingsPane.js